var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay
    ? _c(
        "div",
        {
          staticClass: "preview-item_line",
          style: { "padding-left": _vm.paddingLeft }
        },
        [
          _c(
            "div",
            {
              staticClass: "line-wrapper",
              style: { justifyContent: _vm.textPosition }
            },
            [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.lineText))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "line",
                style: { borderStyle: _vm.lineStyle, width: _vm.width }
              })
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67c1359a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c1359a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemLine.vue
// module id = null
// module chunks = 